exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-dict-select-tag[data-v-33375052] {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n}\n", ""]);

// exports
